import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';

import { FormData } from '@fry/lib/forms';
import { Role, RolesStore } from '@fry/lib/roles';
import { NotifyService } from '@fry/lib/utils';

import { CanComponentDeactivate } from '@fry/components/common/form';
import { RoleForm } from '@fry/components/roles/role.form';


@Component({
    selector: 'app-role-duplicate',
    templateUrl: './role-duplicate.component.html',
    providers: [
        RoleForm
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RoleDuplicateComponent implements OnInit, CanComponentDeactivate {

  public role: Role;
  public formData$: Observable<FormData>;

  constructor(
    private roles: RolesStore,
    private form: RoleForm,
    private route: ActivatedRoute,
    private notify: NotifyService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.route.data.subscribe(
      data => {
        this.role = this.roles.blank(data.role.doc);
        this.role.doc.title = `Copy of ${this.role.doc.title}`;
        this.formData$ = this.form.init(this.role);
      });
  }

  onSubmit() {
      this.form.submit(this.role).subscribe(
        data => {
          this.role = data;
          this.notify.success($localize `Role successfully saved`);
          this.router.navigate(['roles']);
        },
        error => this.notify.error(error)
      );
  }

  canSafelyDeactivate() {
    return this.form.pristine;
  }
}
